import { Navigate, Outlet } from 'react-router-dom';

import { useSession } from '../stores/session';

/**
 * Gate for a route that needs a permission.
 *
 * Presentation only. It decides what to *render*, never what is allowed - the
 * server checks every admin route independently (HANDOFF §6.7), so somebody who
 * edits their permission list in the console reaches a page whose every request
 * 403s.
 *
 * That is the correct division. A client-side check exists so people are not
 * shown doors they cannot open; it is not a lock.
 */
export function RequirePermission({ permission }: { permission: string }) {
  const user = useSession((s) => s.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirected home rather than shown a 403 page. Somebody without the
  // permission has no business knowing the route exists, and there is nothing
  // useful for them to do there.
  return user.permissions?.includes(permission) ? <Outlet /> : <Navigate to="/" replace />;
}
